import { AppsModule } from "./apps/apps.module";
import { CommonModule } from '@angular/common';
import { CountUpModule } from 'ngx-countup';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { DashboardComponent } from './dashboards/dashboard/dashboard.component';
import { DashboardsModule } from "./dashboards/dashboards.module";
import { defineElement } from "@lordicon/element";
import { DemosModule } from "./demos/demos.module";
import { DropdownsModule } from "../core/dropdowns/dropdowns.module";
import { EcommerceModule } from "./ecommerce/ecommerce.module";
import { FlatpickrModule } from 'angularx-flatpickr';
import { FormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LightboxModule } from 'ngx-lightbox';
import lottie from 'lottie-web';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbToastModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { PageComponentsModule } from '../core/page-components/page-components.module';
import { PagesRoutingModule } from "./pages-routing.module";
import { ProvisioningModuleContentShared } from "../pages-content-shared/provisioning-content-shared/provisioning.module-content-shared";
import { SharedModule } from "../shared/shared.module";
import { SimplebarAngularModule } from 'simplebar-angular';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ToastsContainer } from '../shared/toast/toasts-container.component';
import { UsageDashboardComponent } from './dashboards/usage-dashboard/usage-dashboard.component';
import { WidgetModule } from '../shared/widget/widget.module';
import { WidgetRowsModule } from "../shared/widget-rows/widget-rows.module";

@NgModule({
  declarations: [
    DashboardComponent,
    UsageDashboardComponent
  ],
  imports: [
    AppsModule,
    CommonModule,
    CountUpModule,
    DashboardsModule,
    DemosModule,
    DropdownsModule,
    EcommerceModule,
    FlatpickrModule.forRoot(),
    FormsModule,
    LeafletModule,
    LightboxModule,
    NgApexchartsModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    NgbToastModule,
    PageComponentsModule,
    PagesRoutingModule,
    ProvisioningModuleContentShared,
    SharedModule,
    SimplebarAngularModule,
    SlickCarouselModule,
    ToastsContainer,
    WidgetModule,
    WidgetRowsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class PagesModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
